export const translations = {
  Autoplay: 'Autoplay',
  'Autoplay site sounds': 'Autoplay-Seitentöne',
  'Start new game in explore mode.': 'Neues Spiel im Erkundungsmodus starten.',
  'Image selection': 'Auswahl des Bildes',
  'Letters selection': 'Auswahl der Briefe',
  'Tell again': 'Wiederholen Sie',
  'Report an issue': 'Ein Problem melden',
  Contribute: 'Beitragen',
  'Game skipped. Starting the next game in {seconds} seconds.': 'Spiel übersprungen. Start des nächsten Spiels in {seconds} Sekunden.',
  'Amazing. New game will start in {seconds} seconds.': 'Erstaunlich. Neues Spiel wird in {seconds} Sekunden beginnen.',
  Skip: 'überspringen',
  'Warning: this is alpha version of the app. Please be ready to lose you progress in explore mode once. Sorry for inconvenience.': 'Warnung: Dies ist die Alpha-Version der App. Bitte seien Sie bereit, Ihren Fortschritt im Erkundungsmodus einmal zu verlieren. Entschuldigung für die Unannehmlichkeiten.',
  Help: 'Hilfe',
  Leave: 'Verlassen',
  Contest: 'Wettbewerb',
  'Find rival': 'Rivalen finden',
  'Start contest': 'Wettbewerb starten',
  'Start train': 'Zug starten',
  Train: 'Zug',
  Amazing: 'Erstaunlich',
  'Amazing. New round will start in {seconds} seconds.': 'Erstaunlich. Eine neue Runde wird in {seconds} Sekunden beginnen.',
  'Well, but not enough. Try again in {seconds} seconds.': 'Gut, aber nicht genug. Versuchen Sie es in {seconds} Sekunden erneut.',
  'Very well. New round will start in {seconds} seconds.': 'Sehr gut. Eine neue Runde wird in {seconds} Sekunden beginnen.',
  'Very well.': 'Sehr gut',
  'Well done.': 'Well done.',
  Well: 'Quelle',
  'So bad. You can do better!': 'So schlecht. Das kannst du besser!',
  Explore: 'Erkunden',
  'What?': 'Wie?',
  'You won!': 'Du hast gewonnen!',
  'Solve {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.': 'Löse {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet}, um zu {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet} zu gelangen.',
  'Hints limit exceeded. Try to solve {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} again to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.': 'Hinweisgrenze überschritten. Versuchen Sie, {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} erneut zu lösen, um die {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet} zu erreichen',

  // levels
  Simple: 'Einfach',
  Normal: 'Normal',
  Hard: 'Hart'
}
